import { Component, input } from '@angular/core';
import { Card, CardType } from '../../../../../../_interfaces/cards.interface';
import { AvatarComponent } from '../../../../../../shared/components/avatar/avatar.component';

@Component({
  selector: 'app-ng-select-card-label-options',
  imports: [AvatarComponent],
  templateUrl: './ng-select-card-label-template.component.html',
})
export class NgSelectCardLabelTemplateComponent {
  item = input.required<Card>();
  isRecurring = input<boolean>();
  protected readonly CardType = CardType;
}
